
export class UserRole {
  constructor(
    public hash?: string,
    public name?: string,
    public isUser?: boolean,
    public isRole?: boolean
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/user-role.ts